import { chartBooksCategoryId, publicationsCategoryId } from '@3fourteen/core';
import { useCommentary } from 'hooks/useCommentary';
import { memo, useMemo } from 'react';

import { Card, CommentaryItem } from 'components';

function RecentPubCard() {
  const { commentary } = useCommentary([
    'recent-pub',
    { categories: [publicationsCategoryId, chartBooksCategoryId], first: 1 },
  ]);

  const href = useMemo(() => {
    return commentary?.[0] ? `/${commentary?.[0].categorySlug}/${commentary?.[0].slug}` : null;
  }, [commentary]);

  return (
    <Card cardId='recent-pub' className='py-2 px-4 md:py-3 md:px-6' href={href ?? undefined}>
      <CommentaryItem commentary={commentary?.[0]!} useHref={false} showExcerpt={false} />
    </Card>
  );
}

export default memo(RecentPubCard);
